export default "__VITE_ASSET__DkFZlLU___"